import { useRouter } from 'next/router'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { Grid, Flex, Box } from 'components/Layout'
import { LIST_OF_PAGES_WITH_FULL_VIEWPORT } from 'constants/routes'
import { SPACE, COLOR, BORDER_WIDTH, Z_INDEX } from 'Theme'
import { useMedia } from 'useMedia'

export const EXPERT_HEADER_HEIGHT = rem(80)

const StyledHeader = styled(Grid)`
  background: ${COLOR.GRAYSCALE_6};
  border-bottom: 1px solid ${COLOR.GRAYSCALE_5};
`

const StyledFlex = styled(Flex)`
  border-top: ${BORDER_WIDTH.PX_1} solid ${COLOR.GRAYSCALE_5};
  background: ${COLOR.GRAYSCALE_6};
`

interface HeaderProps {
  leftElement?: () => React.ReactNode
  rightElement?: () => React.ReactNode
}

export const Header: React.FC<React.PWC<HeaderProps>> = ({
  children,
  leftElement,
  rightElement,
  ...rest
}) => {
  const router = useRouter()
  const media = useMedia()

  if (media.isReady && media.MOBILE && (leftElement || rightElement)) {
    return (
      <StyledFlex
        p={{ MOBILE: SPACE.PX_10, TABLET: SPACE.PX_20 }}
        justifyContent="space-between"
        alignItems="center"
        bottom={0}
        {...(!LIST_OF_PAGES_WITH_FULL_VIEWPORT.includes(router.pathname)
          ? { position: 'fixed' }
          : { order: 1 })}
        width="100%"
        zIndex={Z_INDEX.SIDENAV}
        {...rest}
      >
        <Box>{leftElement?.()}</Box>
        <Box>{rightElement?.()}</Box>
      </StyledFlex>
    )
  }

  if (media.isReady && !media.MOBILE) {
    return (
      <StyledHeader
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        gridTemplateColumns="auto auto auto"
        p={`${SPACE.PX_20} ${SPACE.PX_30}`}
        height={EXPERT_HEADER_HEIGHT}
        {...rest}
      >
        <Flex alignItems="center">{leftElement?.()}</Flex>
        <Flex justifyContent="center" alignItems="center">
          {children}
        </Flex>
        <Flex alignItems="center" justifyContent="flex-end">
          {rightElement?.()}
        </Flex>
      </StyledHeader>
    )
  }

  return null
}
